import { Button, Checkbox, Input, Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";
import formatNumberWithSpaces from "../../../../Components/NumberToWords/FormatNumber";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";
import axiosInstance from "../../../../Components/axiosInstance/AxiosInstance";
import { useParams } from "react-router-dom";
import { OneCustomer } from "../../../../Stores/Customers/OneCustomer";

export default function EditMyTickete({ open, setOpen, data, setData }) {
  // let [data, setData] = useState(null);
  const { id } = useParams();
  const { fetchData } = OneCustomer();
  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const handleKeyDown = (e, index) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      // Prevent date value from changing
      if (e.target.type === "date") {
        e.preventDefault();
      }
      if (e.key === "ArrowDown") {
        // Focus the next input (if it exists)
        if (index < inputRefs.length - 1) {
          inputRefs[index + 1].current.focus();
        }
      } else if (e.key === "ArrowUp") {
        // Focus the previous input (if it exists)
        if (index > 0) {
          inputRefs[index - 1].current.focus();
        }
      }
    }
  };
  // /api/akt_svetka
  let akt_svetkaAdd = async () => {
    try {
      let { data: info } = await axiosInstance.put(
        "/api/akt_svetka/" + data?.id,
        {
          customer_id: id,
          ...data,
        }
      );
      setOpen(false);
      setData(null);
      fetchData(id);
      console.log(info);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  //   let contracts = [
  //     { number: 428747, name: "Аммофос", from: "111 - ombor ozimizdan" },
  //     { number: 429033, name: "Аммофос", from: "111 - ombor ozimizdan" },
  //     { number: 97504, name: "Сульфат", from: "111 - ombor ozimizdan" },
  //     { number: 429181, name: "Сульфат", from: "111 - ombor ozimizdan" },
  //     { number: 99429181, name: "Сульфат", from: "111 - ombor ozimizdan" },
  //     { number: 429228, name: "Селитра", from: "111 - ombor ozimizdan" },
  //     { number: 430098, name: "Селитра", from: "111 - ombor ozimizdan" },
  //     { number: 99429228, name: "Селитра", from: "111 - ombor ozimizdan" },
  //     { number: 99430098, name: "Селитра", from: "111 - ombor ozimizdan" },
  //     { number: 9997505, name: "Селитра", from: "111 - ombor ozimizdan" },
  //     { number: 97180, name: "Karbamid", from: "111 - ombor ozimizdan" },
  //     { number: 429314, name: "Супрефос", from: "111 - ombor ozimizdan" },
  //     { number: 429999, name: "Супрефос", from: "111 - ombor ozimizdan" },
  //     { number: 99429314, name: "Супрефос", from: "111 - ombor ozimizdan" },
  //     { number: 99429999, name: "Супрефос", from: "111 - ombor ozimizdan" },
  //     { number: 428794, name: "KALIY", from: "111 - ombor ozimizdan" },
  //     { number: 9997504, name: "Сульфат", from: "111 - ombor ozimizdan (eski)" },
  //     { number: 9994749, name: "Аммофос", from: "111 - ombor ozimizdan (eski)" },
  //   ];

  let contracts = [
    { number: 426352, name: "Аммофос", from: "111 - ombor ozimizdan -- eski " },
    {
      number: 99426352,
      name: "Аммофос",
      from: "111 - ombor ozimizdan -- eski ",
    },
    { number: 428747, name: "Аммофос", from: "111 - ombor ozimizdan" },
    { number: 429033, name: "Аммофос", from: "111 - ombor ozimizdan" },
    { number: 97504, name: "Сульфат", from: "111 - ombor ozimizdan" },
    { number: 429181, name: "Сульфат", from: "111 - ombor ozimizdan" },
    { number: 99429181, name: "Сульфат", from: "111 - ombor ozimizdan" },
    { number: 429228, name: "Селитра", from: "111 - ombor ozimizdan" },
    { number: 430098, name: "Селитра", from: "111 - ombor ozimizdan" },
    { number: 99429228, name: "Селитра", from: "111 - ombor ozimizdan" },
    { number: 99430098, name: "Селитра", from: "111 - ombor ozimizdan" },
    { number: 9997505, name: "Селитра", from: "111 - ombor ozimizdan" },
    { number: 97180, name: "Karbamid", from: "111 - ombor ozimizdan" },
    { number: 429314, name: "Супрефос", from: "111 - ombor ozimizdan" },
    { number: 429999, name: "Супрефос", from: "111 - ombor ozimizdan" },
    { number: 99429314, name: "Супрефос", from: "111 - ombor ozimizdan" },
    { number: 99429999, name: "Супрефос", from: "111 - ombor ozimizdan" },
    { number: 428794, name: "KALIY", from: "111 - ombor ozimizdan" },
    { number: 431205, name: "KALIY", from: "111 - ombor ozimizdan" },
    { number: 9997504, name: "Сульфат", from: "111 - ombor ozimizdan (eski)" },
    { number: 9994749, name: "Аммофос", from: "111 - ombor ozimizdan (eski)" },
    { number: 94681, name: "Аммофос", from: "111 - ombor ozimizdan (eski)" },
    { number: 9994681, name: "Аммофос", from: "111 - ombor ozimizdan (eski)" },
    { number: 94749, name: "Аммофос", from: "111 - ombor ozimizdan (eski)" },
    { number: 9994749, name: "Аммофос", from: "111 - ombor ozimizdan (eski)" },
    { number: 94847, name: "Аммофос", from: "111 - ombor ozimizdan (eski)" },
    { number: 9994847, name: "Аммофос", from: "111 - ombor ozimizdan (eski)" },
    { number: 73021, name: "Селитра", from: "111 - ombor ozimizdan (eski)" },
    { number: 9973021, name: "Селитра", from: "111 - ombor ozimizdan (eski)" },
    { number: 92399, name: "Селитра", from: "111 - ombor ozimizdan (eski)" },
    { number: 93007, name: "Сульфат", from: "111 - ombor ozimizdan (eski)" },
    { number: 9993007, name: "Сульфат", from: "111 - ombor ozimizdan (eski)" },
    { number: 95411, name: "Калий", from: "111 - ombor ozimizdan (eski)" },
    { number: 95406, name: "Калий", from: "111 - ombor ozimizdan (eski)" },
    { number: 95952, name: "Карбамид", from: "111 - ombor ozimizdan (eski)" },
    { number: 92345, name: "Карбамид", from: "111 - ombor ozimizdan (eski)" },
    { number: 92644, name: "Селитра", from: "111 - ombor ozimizdan (eski)" },
    { number: 92650, name: "Селитра", from: "111 - ombor ozimizdan (eski)" },
    { number: 9992948, name: "Сульфат", from: "111 - ombor ozimizdan (eski)" },
  ];
  let products = {
    n99426352: "Аммофос",
    n426352: "Аммофос",
    n428747: "Аммофос",
    n429033: "Аммофос",
    n97504: "Сульфат",
    n429181: "Сульфат",
    n99429181: "Сульфат",
    n429228: "Селитра",
    n430098: "Селитра",
    n99429228: "Селитра",
    n99430098: "Селитра",
    n9997505: "Селитра",
    n97180: "Karbamid",
    n429314: "Супрефос",
    n429999: "Супрефос",
    n99429314: "Супрефос",
    n99429999: "Супрефос",
    n428794: "KALIY",
    n431205: "KALIY",
    n9997504: "Сульфат",
    n9994749: "Аммофос",
    n94681: "Аммофос",
    n9994681: "Аммофос",
    n94749: "Аммофос",
    n94847: "Аммофос",
    n9994847: "Аммофос",
    n73021: "Селитра",
    n9973021: "Селитра",
    n92399: "Селитра",
    n93007: "Сульфат",
    n9993007: "Сульфат",
    n95411: "Калий",
    n95406: "Калий",
    n95952: "Карбамид",
    n92345: "Карбамид",
    n92644: "Селитра",
    n92650: "Селитра",
    n9992948: "Сульфат",
  };

  return (
    <Modal
      style={{ top: "10px" }}
      title="Tiket kiritish!"
      open={open}
      //   loading={loadVagon}
      onOk={() => {
        setOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setOpen(false);
      }}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            akt_svetkaAdd();
            console.log(data);
          }}
        >
          Saqlash
        </Button>,
      ]}
    >
      <div>
        <label className="text-[16px] ">Tiket -- {data?.producer}</label>
        <Input
          type="text"
          placeholder="Tiket"
          value={data?.ticket}
          ref={inputRefs[1]}
          onKeyDown={(e) => {
            handleKeyDown(e, 0);
          }}
          onChange={(e) => {
            setData({
              ...data,
              ticket: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Nomi</label>
        <Input
          type="text"
          placeholder="Nomi"
          value={data?.name}
          ref={inputRefs[1]}
          onKeyDown={(e) => {
            handleKeyDown(e, 0);
          }}
          onChange={(e) => {
            setData({
              ...data,
              name: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">
          Kantrakt raqami --{" "}
          {
            contracts?.filter((el) => {
              if (el?.number == Number(data?.contract_no)) {
                return el;
              }
            })[0]?.from
          }
          {" -- "}
          {
            contracts?.filter((el) => {
              if (el?.number == Number(data?.contract_no)) {
                return el;
              }
            })[0]?.name
          }
        </label>
        <Input
          type="text"
          placeholder="Kantrakt raqami"
          value={data?.contract_no}
          ref={inputRefs[1]}
          onKeyDown={(e) => {
            handleKeyDown(e, 0);
          }}
          onChange={(e) => {
            setData({
              ...data,
              contract_no: e.target.value,
            });
          }}
        />
        <label className="text-[16px] "> Sana</label>
        <Input
          type="date"
          placeholder="time"
          value={data?.date?.split("T")[0]}
          ref={inputRefs[1]}
          onKeyDown={(e) => {
            handleKeyDown(e, 0);
            if (e.key === "F2") {
              const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
              setData({
                ...data,
                date: currentDate,
              });
            }
          }}
          onChange={(e) => {
            setData({
              ...data,
              date: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Tonna</label>
        <Input
          type="text"
          placeholder="Tonna"
          value={data?.tonna}
          ref={inputRefs[1]}
          onKeyDown={(e) => {
            handleKeyDown(e, 0);
          }}
          onChange={(e) => {
            setData({
              ...data,
              tonna: e.target.value,
            });
          }}
        />

        <label className="text-[16px] ">
          Summa {formatNumberWithSpaces(data?.sum ? data?.sum : 0)}
        </label>
        <Input
          type="text"
          placeholder="Summani kiriting"
          autoFocus={true}
          value={data?.sum}
          ref={inputRefs[4]}
          onKeyDown={(e) => {
            handleKeyDown(e, 1);
          }}
          onChange={(e) => {
            setData({
              ...data,
              sum: e.target.value,
            });
          }}
        />

        <label className="text-[16px] ">
          Izoh {data?.bk == "9506" ? "-- Qosim aka" : "Boshqa brokker"}
        </label>
        <TextArea
          rows={4}
          placeholder="Type your text here..."
          value={data?.comment}
          ref={inputRefs[13]}
          onKeyDown={(e) => {
            handleKeyDown(e, 0);
            if (e.key === "F2") {
              // console.log(data?.comment?.split("\t"));
              let datas = data?.comment?.split("\t");

              setData({
                ticket: datas[0], // required
                date: moment(datas[1], "DD.MM.YYYY").format("YYYY-MM-DD"), // required
                producer: datas[3], // required
                bk: datas[4], // required
                name: products["n" + datas[6]],
                brokker: data?.bk == "9506" ? "-- Qosim aka" : "Boshqa brokker",
                contract_no: datas[6],

                tonna:
                  datas[7]?.split(" ")[1] != "tn"
                    ? datas[7]?.split(" ")[0] / 1000
                    : datas[7]?.split(" ")[0], // required
                sum: datas[9]?.split(",")[0], // required
                comment: datas
                  ?.map((el, i) => {
                    if (i == 7 && el?.split(" ")[1] != "tn") {
                      return el?.split(" ")[0] / 1000 + " tn";
                    }

                    return el;
                  })
                  ?.join("\t"), // optional
              });
            }
          }}
          onChange={(e) => {
            setData({
              ...data,
              comment: e.target.value,
            });
          }}
        />
      </div>
    </Modal>
  );
}
